"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ImageGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const gridItems = [{
    id: 1,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/collaborative_accounting_team_meeting.png",
    title: "Team Collaboration",
    description: "Expert accountants working together to deliver exceptional results."
  }, {
    id: 2,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/modern_accounting_workspace.png",
    title: "Modern Workspace",
    description: "State-of-the-art facilities designed for productivity and comfort."
  }, {
    id: 3,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/client_consultation_session.png",
    title: "Client Consultation",
    description: "Personalized advisory services tailored to your business needs."
  }, {
    id: 4,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/financial_planning_discussion.png",
    title: "Financial Planning",
    description: "Strategic planning to help your business grow and thrive."
  }];
  return <section id="image-grid" ref={ref} className="bg-background py-24 md:py-32 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className={`grid grid-cols-1 md:grid-cols-2 gap-8 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {gridItems.map((item, i) => <Card key={item.id} data-index={i} className="group overflow-hidden bg-surface border border-border shadow-soft hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] p-0">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 ease-[var(--ease-smooth)] group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-dark-section/80 via-dark-section/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" />
              </div>
              <CardContent className="p-8 relative">
                <div className="flex flex-col gap-4">
                  <h3 className="text-2xl font-semibold text-foreground leading-tight">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {item.description}
                  </p>
                  <div className="pt-2">
                    <Button asChild className="rounded-[var(--radius-full)] bg-primary text-foreground-primary hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5 transition-all duration-[var(--duration-fast)] focus-visible:ring-ring px-6 py-3 font-semibold shadow-soft">
                      <Link to="#">More</Link>
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}